module.exports = __webpack_public_path__ + "static/media/desktopScreenshot03.254a1319.jpg";